// TODO Eugene - получить из конфига

const tempPhoneMask = '+7 (000) 000-00-00';

export default tempPhoneMask;
